<template>
  <b-sidebar
    id="sidebar-create-user"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ user.id ? $t('Update User') : 'Create User' }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <b-form-group
          :label="$t('Role')"
          label-for="role"
        >
          <v-select
            id="role"
            v-model="user.role_id"
            :reduce="(option) => option.id"
            :options="roles"
            :get-option-label="(option) => option.name[$i18n.locale]"
          />
        </b-form-group>

        <b-form-group
          :label="$t('Organization')"
          label-for="org"
        >
          <v-select
            id="org"
            v-model="user.org_id"
            :reduce="(option) => option.id"
            :options="organizations"
            :get-option-label="(option) => $langName(option.name)"
          />
        </b-form-group>

        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ user.id ? $t('Update User') : $t('Create User') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  computed: {
    organizations() {
      return this.$store.state.organization.organizations
    },
    roles() {
      return this.$store.state.staticModule.roles
    },
    user: {
      get() {
        return this.$store.state.user.user
      },
      set(user) {
        this.$store.commit('user/UPDATE', user)
      },
    },
  },
  methods: {
    clear(hide) {
      this.$store.commit('user/FRESH')
      hide()
    },
    submit(hide) {
      this.$confirmCode({
        callback: (confirm, smsCode) => {
          if (confirm) {
            this.$createSwal(this, { id: this.user.id, body: this.user, smsCode }, 'user/patch', () => {
              this.$emit('refetchData')
              this.$store.commit('user/FRESH')
            })
            hide()
          }
        },
      })
    },
  },
}
</script>
